<div class="container-fluid">
  <div class="row">
    <div class="col-12 py-5 text-center">
      <div class="d-flex justify-content-center">
        <h1 class="mx-4">
          <a href="https://www.facebook.com/Buurtzorg-Nederland-201640399858073/" target="_blank"><fa-icon [icon]="['fab', 'facebook']"></fa-icon></a>
        </h1>
        <h1 class="mx-4">
          <a href="https://www.linkedin.com/company/buurtzorg/" target="_blank"><fa-icon [icon]="['fab', 'linkedin']"></fa-icon></a>
        </h1>
        <h1 class="mx-4">
          <a href="https://twitter.com/buurtzorg" target="_blank"><fa-icon [icon]="['fab', 'twitter']"></fa-icon></a>
        </h1>
      </div>
      <div class="my-2">
        <small><a href="https://buurtzorgnederland.com"> Buurtzorg Nederland</a></small>
      </div>
      <div class="my-2">
        <small><a href="https://buurtzorg.net">Buurtzorg Teams</a></small>
      </div>
      <!-- <div class="mb-2">
        <small><a href="https://keuringsdienstvanbanen.nl">Keuringsdienst van banen</a></small>
      </div> -->
      <hr class="mb-5" />

      <div class="my-2">
        <small>Copyright © 2020 Buurtzorg Nederland. Alle rechten voorbehouden.</small>
      </div>
      <div class="my-2">
        <small><a href="javascript:void(0)" (click)="openPrivacySettings()">Privacy-instellingen</a></small>
      </div>
    </div>
  </div>
</div>
